import { createFileRoute } from '@tanstack/react-router';
import { OfferNewPage } from '../../features/rfq';

export const Route = createFileRoute('/portal/offers/new')({ component: OfferNewPage });
